import { redirect, type RouteObject } from 'react-router-dom';
import { Root } from './Root.tsx';
import { authenticate, authorize } from './middleware/auth.middleware.ts';
import { ROLES } from './redux/api/user.api.ts';
import { ErrorRoot } from './ErrorRoot.tsx';

export const router: RouteObject[] = [
  {
    path: '/',
    middleware: [authenticate()],
    Component: Root,
    ErrorBoundary: ErrorRoot,
    children: [
      {
        index: true,
        handle: { pageTitle: 'Conflicts of Interest Search Requests' },
        loader() {
          throw redirect('/myforms');
        },
      },
      {
        path: 'not-found',
        handle: { pageTitle: 'Not Found' },
        lazy: () => import('./pages/NotFound/NotFound.tsx'),
      },
      {
        path: 'create',
        handle: { pageTitle: 'Create Form' },
        middleware: [
          authorize([ROLES.VIEW_ONLY, ROLES.ADMIN, ROLES.USER, ROLES.REVIEWER, ROLES.QL]),
        ],
        lazy: () => import('./pages/CreateForm/CreateForm.tsx'),
      },
      {
        path: 'myforms',
        handle: { pageTitle: 'Conflicts of Interest Search Requests' },
        children: [
          {
            index: true,
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [
              authorize([ROLES.VIEW_ONLY, ROLES.ADMIN, ROLES.USER, ROLES.REVIEWER, ROLES.QL]),
            ],
            lazy: () => import('./pages/FormSearch/MyFormsSearch.tsx'),
          },
          {
            path: ':formid',
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [
              authorize([ROLES.REVIEWER, ROLES.VIEW_ONLY, ROLES.ADMIN, ROLES.USER, ROLES.QL]),
            ],
            lazy: () => import('./pages/FormDetails/MyForms/MyForms.tsx'),
          },
        ],
      },
      {
        path: 'allforms',
        children: [
          {
            index: true,
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [
              authorize([ROLES.ADMIN, ROLES.VIEW_ONLY, ROLES.USER, ROLES.REVIEWER, ROLES.QL]),
            ],
            lazy: () => import('./pages/FormSearch/AllFormSearch/AllFormSearch.tsx'),
          },
          {
            path: ':formid',
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [
              authorize([ROLES.ADMIN, ROLES.VIEW_ONLY, ROLES.USER, ROLES.REVIEWER, ROLES.QL]),
            ],
            lazy: () => import('./pages/FormDetails/MyForms/MyForms.tsx'),
          },
        ],
      },
      {
        path: 'myapprovals',
        children: [
          {
            index: true,
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [authorize([ROLES.ADMIN, ROLES.REVIEWER, ROLES.QL])],
            lazy: () => import('./pages/FormSearch/MyApprovals/MyApprovals.tsx'),
          },
          {
            path: ':formid',
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [authorize([ROLES.ADMIN, ROLES.REVIEWER, ROLES.QL])],
            lazy: () => import('./pages/FormDetails/MyApprovalsDetail/MyApprovalsDetail.tsx'),
          },
        ],
      },
      {
        path: 'allapprovals',
        children: [
          {
            index: true,
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [authorize([ROLES.ADMIN, ROLES.REVIEWER, ROLES.QL])],
            lazy: () => import('./pages/FormSearch/AllApprovals/AllApprovals.tsx'),
          },
          {
            path: ':formid',
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [authorize([ROLES.ADMIN, ROLES.REVIEWER, ROLES.QL])],
            lazy: () => import('./pages/FormDetails/AllApprovalsDetail/AllApprovalsDetail.tsx'),
          },
        ],
      },
      {
        path: 'qualityandrisk',
        children: [
          {
            index: true,
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [
              authorize([ROLES.ADMIN, ROLES.VIEW_ONLY, ROLES.USER, ROLES.REVIEWER, ROLES.QL]),
            ],
            lazy: () => import('./pages/FormSearch/QualityAndRisk/QualityAndRisk.tsx'),
          },
          {
            path: ':formid',
            handle: { pageTitle: 'Conflicts of Interest Search Requests' },
            middleware: [
              authorize([ROLES.ADMIN, ROLES.VIEW_ONLY, ROLES.USER, ROLES.REVIEWER, ROLES.QL]),
            ],
            lazy: () =>
              import('./pages/FormDetails/QualityAndRiskDetails/QualityAndRiskDetails.tsx'),
          },
        ],
      },
      {
        path: 'adminview',
        middleware: [authorize([ROLES.ADMIN])],
        children: [
          {
            path: 'managequalityleaders',
            handle: { pageTitle: 'Manage Quality Leaders' },
            middleware: [authorize([ROLES.ADMIN])],
            lazy: () => import('./pages/AdminView/ManageQualityLeaders/ManageQualityLeaders.tsx'),
          },
          {
            path: 'emailtypes',
            handle: { pageTitle: 'Email Types' },
            middleware: [authorize([ROLES.ADMIN])],
            children: [
              {
                index: true,
                lazy: () => import('./pages/AdminView/EmailTemplates/EmailTemplates.tsx'),
              },
              {
                path: 'createnewemailtemplate',
                handle: { pageTitle: 'Email Template View' },
                lazy: () => import('./pages/AdminView/EmailTemplates/EmailTemplateView.tsx'),
              },
              {
                path: ':templateId',
                handle: { pageTitle: 'Email Template View' },
                lazy: () => import('./pages/AdminView/EmailTemplates/EmailTemplateView.tsx'),
              },
            ],
          },
        ],
      },
      {
        path: '/unauthorized',
        handle: { pageTitle: 'Unauthorized' },
        lazy: () => import('./pages/Unauthorized/Unauthorized.tsx'),
      },
      {
        path: '*',
        loader() {
          throw redirect('/not-found');
        },
      },
    ],
  },
];
